import { render } from "./RevenueExpenseChart.vue?vue&type=template&id=b00426a2"
import script from "./RevenueExpenseChart.vue?vue&type=script&lang=js"
export * from "./RevenueExpenseChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__